var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "stepOut" }, [
    _c(
      "div",
      { staticClass: "stepItem" },
      [
        _c("el-image", {
          staticClass: "stepItem_img",
          attrs: {
            src:
              _vm.stepInfo.status >= 1
                ? "http://small.jianchiyaoye.com/icon_xiadan_activate.png"
                : "http://small.jianchiyaoye.com/icon_xiadan_default.png",
            alt: "",
          },
        }),
        _c("p", { class: _vm.stepInfo.status >= 1 ? "blue" : "gray" }, [
          _vm._v("买家下单"),
        ]),
        _c("p", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.stepInfo.buyerPlaceOrderTime)),
        ]),
        _c("div", {
          class:
            _vm.stepInfo.status >= 1
              ? "stepItem_xian lineAction"
              : "stepItem_xian",
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "stepItem shenheStatus" },
      [
        _c("el-image", {
          staticClass: "stepItem_img",
          attrs: {
            src:
              _vm.stepInfo.status >= 2
                ? "http://small.jianchiyaoye.com/icon_fukuan_activate.png"
                : "http://small.jianchiyaoye.com/icon_fukuan_default.png",
            alt: "",
          },
        }),
        _c("p", { class: _vm.stepInfo.status >= 2 ? "blue" : "gray" }, [
          _vm._v("付款成功"),
        ]),
        _c("p", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.stepInfo.paidTime)),
        ]),
        _c("div", {
          class:
            _vm.stepInfo.status >= 2
              ? "stepItem_xian lineAction"
              : "stepItem_xian",
        }),
        _vm.statustype == 3 ? _c("div", { staticClass: "close" }) : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "stepItem" },
      [
        _c("el-image", {
          staticClass: "stepItem_img",
          attrs: {
            src:
              _vm.stepInfo.status >= 3 && _vm.stepInfo.status != "99"
                ? "http://small.jianchiyaoye.com/icon_fahuo_activate.png"
                : "http://small.jianchiyaoye.com/icon_fahuo_default.png",
            alt: "",
          },
        }),
        _c(
          "p",
          {
            class:
              _vm.stepInfo.status >= 3 && _vm.stepInfo.status != "99"
                ? "blue"
                : "gray",
          },
          [_vm.deliveryType == 2 ? [_vm._v("自提中")] : [_vm._v("商家发货")]],
          2
        ),
        _c("p", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.stepInfo.merchantShippingTime)),
        ]),
        _c("div", {
          class:
            _vm.stepInfo.status >= 3 && _vm.stepInfo.status != "99"
              ? "stepItem_xian lineAction"
              : "stepItem_xian",
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "stepItem" },
      [
        _c("el-image", {
          staticClass: "stepItem_img",
          attrs: {
            src:
              _vm.stepInfo.status >= 4 && _vm.stepInfo.status != "99"
                ? "http://small.jianchiyaoye.com/icon_wancheng_activate.png"
                : "http://small.jianchiyaoye.com/icon_wancheng_default.png",
            alt: "",
          },
        }),
        _c(
          "p",
          {
            class:
              _vm.stepInfo.status >= 4 && _vm.stepInfo.status != "99"
                ? "blue"
                : "gray",
          },
          [_vm._v("交易完成")]
        ),
        _c("p", { staticClass: "time" }, [
          _vm._v(_vm._s(_vm.stepInfo.completeTransactionTime)),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }